
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"31.705","height":"31.705","viewBox":"0 0 31.705 31.705"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 140"}},[_c('g',{attrs:{"data-name":"Group 139"}},[_c('path',{staticClass:"cls-2",attrs:{"d":"M15.853 8.726c2.321 0 2.6.009 3.512.051a4.8 4.8 0 011.614.3 2.881 2.881 0 011.65 1.65 4.814 4.814 0 01.3 1.614c.041.916.051 1.191.051 3.512s-.009 2.6-.051 3.512a4.813 4.813 0 01-.3 1.614 2.877 2.877 0 01-1.65 1.649 4.808 4.808 0 01-1.614.3c-.917.042-1.191.051-3.512.051s-2.6-.009-3.512-.051a4.813 4.813 0 01-1.614-.3 2.878 2.878 0 01-1.65-1.649 4.812 4.812 0 01-.3-1.614c-.041-.917-.05-1.191-.05-3.512s.009-2.6.05-3.512a4.812 4.812 0 01.3-1.614 2.881 2.881 0 011.65-1.65 4.8 4.8 0 011.614-.3c.917-.042 1.191-.051 3.512-.051m0-1.566c-2.36 0-2.657.01-3.584.052a6.4 6.4 0 00-2.11.4 4.438 4.438 0 00-2.542 2.542 6.366 6.366 0 00-.4 2.11c-.042.927-.052 1.223-.052 3.583s.01 2.657.052 3.584a6.366 6.366 0 00.4 2.11 4.443 4.443 0 002.542 2.542 6.385 6.385 0 002.11.4c.927.043 1.223.052 3.584.052s2.657-.009 3.584-.052a6.384 6.384 0 002.11-.4 4.447 4.447 0 002.542-2.542 6.385 6.385 0 00.4-2.11c.042-.927.052-1.223.052-3.584s-.01-2.657-.052-3.583a6.386 6.386 0 00-.4-2.11 4.442 4.442 0 00-2.542-2.542 6.4 6.4 0 00-2.11-.4c-.927-.042-1.223-.052-3.584-.052","data-name":"Path 822","fill":"#fff"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M15.853 11.389a4.463 4.463 0 104.464 4.463 4.464 4.464 0 00-4.464-4.463m0 7.36a2.9 2.9 0 112.9-2.9 2.9 2.9 0 01-2.9 2.9","data-name":"Path 823","fill":"#fff"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M21.536 11.213a1.043 1.043 0 11-1.043-1.044 1.043 1.043 0 011.043 1.044","data-name":"Path 824","fill":"#fff"}})])])])
          )
        }
      }
    